import {Box, Button, Divider, Grid, ListItem, Paper} from '@mui/material';
import React, {useState} from 'react';
import {PropsFromReduxLeadImplant} from '../containers/LeadImplantContainers';
import {useSelector} from 'react-redux';
import {canAddModifyDeletePatientData} from '../../auth/selectors/authSelector';
import ModalLeadImplant from './ModalLeadImplant';

const LeadImplantComponent = (props: PropsFromReduxLeadImplant) => {
  const [addLeadImplantModal, setAddLeadImplantModal] = useState(false);
  const hasLeadImplant = props.patient?.leadImplantList.length > 0
  const hasPermissionToUpdatePatientData = useSelector(
      canAddModifyDeletePatientData,
  )
  const onAddLeadImplant = () => {
    setAddLeadImplantModal(true)
    // TODO open modal
  }
  
  return (
      <>
        <ModalLeadImplant
            isOpen={addLeadImplantModal}
            setIsOpen={setAddLeadImplantModal}
            patientId={props.patientId}
            />
        <ListItem
            sx={{ display: 'flex', alignItems: 'start' }}
        >
          <Grid
              container
              direction="column"
              sx={{ width: '100%', padding: '15px' }}
          >
            <Paper elevation={4} sx={{ width: '100%' }}>
              <Box
                  sx={{
                    padding: '16px',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
              >
                <span
                    style={{
                      fontWeight: 'bold',
                      color: '#84c2ce',
                    }}
                >
                  Sonde(s) :
                </span>
                <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '6px',
                    }}
                >
                  {hasPermissionToUpdatePatientData && (
                      <Button
                          type="submit"
                          variant="contained"
                          className="button-base"
                          disabled={
                            props.patient?.leadImplantList.length === 3
                          }
                          onClick={() => onAddLeadImplant()}
                      >
                        Ajouter une sonde
                      </Button>
                  )}
                </div>
              </Box>
              <Divider />
              <Box
                  sx={{
                    padding: '16px',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
              >
                {!hasLeadImplant && (
                  <span
                      style={{
                        fontWeight: 'bold',
                        color: '#84c2ce',
                      }}
                  >
                    Aucune sonde
                  </span>
                  )}
                
              </Box>
            </Paper>
          </Grid>
        </ListItem>
      </>
  );
};

export default LeadImplantComponent
